module.exports = __webpack_public_path__ + "assets/images/extra-03.8314234de96814d4c703e81ab2a32fef.svg";